import React, { useState, useEffect } from "react";
import {
  Container,
  Row,
  Col,
  Card,
  Form,
  InputGroup,
  Button,
  Badge,
} from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSearch } from "@fortawesome/free-solid-svg-icons";
import { useNavigate } from "react-router-dom";
import { AuthContext } from "../../context/AuthContext";
import { useContext } from "react";
import { dictionaryService } from "../../services/api";
import "../../styles/DictionaryList.css"; // Import du fichier CSS

const DictionaryAdminList = () => {
  const { currentUser } = useContext(AuthContext);
  const [isAdmin, setIsAdmin] = useState(false);

  useEffect(() => {
    if (currentUser) {
      const isAdmin = currentUser.profile.role === "admin";
      console.log("is", isAdmin);
      setIsAdmin(isAdmin);
    }
  }, [currentUser]);

  const navigate = useNavigate();
  const [entries, setEntries] = useState([]);
  const [page, setPage] = useState(1);
  const [max_entries, setMaxEntries] = useState(11);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [searchTerm, setSearchTerm] = useState("");
  const [filters, setFilters] = useState({
    wordType: "",
    region: "",
    status: "",
  });

  useEffect(() => {
    const fetchEntries = async () => {
      try {
        setLoading(true);
        const params = new URLSearchParams();
        params.append("page", page);
        if (searchTerm) params.append("q", searchTerm);

        if (isAdmin) {
          params.append("status", "pending");
        }

        const response = await dictionaryService.getAllEntries(params);
        console.log("Réponse de l'API:", response.data);
        setEntries(response.data.results);
        setMaxEntries(response.data.count);
        setError(null);
      } catch (err) {
        setError("Impossible de charger les entrées.");
      } finally {
        setLoading(false);
      }
    };
    fetchEntries();
  }, [searchTerm, filters, page, isAdmin]);

  return (
    <div className="dictionary-container">
      <Container className="my-5">
        <div className="content-wrapper">
          <h1 className="dictionary-title">
            Exploiter la Richesse du Dialecte Algerien Sur DzWordnet
          </h1>

          {/* Barre de recherche stylisée */}
          <div className="dict-searchbar">
            <input
              type="text"
              placeholder="Rechercher un terme dans le dictionnaire"
              value={searchTerm}
              onChange={(e) => {
                setSearchTerm(e.target.value);
              }}
            />
            <span className="dict-search-ico">
              <FontAwesomeIcon icon={faSearch} />
            </span>
          </div>

          {/* Messages d'état */}
          {loading && (
            <div className="loading-message">
              Chargement des entrées du dictionnaire...
            </div>
          )}

          {entries.length === 0 && !loading && (
            <div className="no-entries-message">
              Aucune entrée trouvée dans le dictionnaire.
            </div>
          )}

          {/* Tableau des entrées */}
          {entries.length > 0 && !loading && (
            <div className="dictionary-table-container">
              <table className="dictionary-table">
                <thead>
                  <tr>
                    <th>ID</th>
                    <th>Mot Arabe</th>
                    <th>Mot Français</th>
                    <th>Status</th>
                    <th>Actions</th>
                  </tr>
                </thead>
                <tbody>
                  {entries.map((entry, index) => (
                    <tr key={entry.id}>
                      <td>
                        <span className="entry-id">#{entry.id}</span>
                      </td>
                      <td>
                        <div className="arabic-word">{entry.arabic_word}</div>
                      </td>
                      <td>
                        <div className="french-word">
                          {entry.translation ||
                            entry.french_translation ||
                            "Non traduit"}
                        </div>
                      </td>
                      <td>
                        <div className="french-word">
                          {entry.status || "Non Déterminé"}
                        </div>
                      </td>
                      <td>
                        <Button
                          className="detail-button"
                          onClick={() => navigate(`/dictionary/${entry.id}`)}
                        >
                          Voir Détails
                        </Button>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          )}

          {/* Espaceur pour pousser le contenu */}
          <div className="content-spacer"></div>

          {/* Bouton Charger plus */}
          {max_entries > page * 10 && !loading && (
            <div className="load-more-container">
              <Button
                className="load-more-button"
                onClick={() => setPage(page + 1)}
              >
                Charger Plus d'Entrées
              </Button>
            </div>
          )}
        </div>
      </Container>
    </div>
  );
};

export default DictionaryAdminList;
